'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _PromotionAtSpa = require('./PromotionAtSpa');

var _PromotionAtSpa2 = _interopRequireDefault(_PromotionAtSpa);

var _FiveStarPromotion = require('./FiveStarPromotion');

var _FiveStarPromotion2 = _interopRequireDefault(_FiveStarPromotion);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromotionMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    tabHome: state.voucher.tabHome,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST,
    REWARD_LIST_NO_STAR: state.voucher.REWARD_LIST_NO_STAR,
    REWARD_LIST_FIVE_STAR: state.voucher.REWARD_LIST_FIVE_STAR,
    REWARD_LIST_AT_SPA: state.voucher.REWARD_LIST_AT_SPA,
    SERVICE_OF_HOME_SERVICE: state.shops.SERVICE_OF_HOME_SERVICE
  };
}, {
  getAllReward: voucherActions.getAllReward,
  getRewardAtSpa: voucherActions.getRewardAtSpa,
  getRewardAtHome: voucherActions.getRewardAtHome,
  getMyReward: voucherActions.getMyReward,
  changeHomeTab: voucherActions.changeHomeTab,
  loadServiceOfHomeService: shopActions.loadServiceOfHomeService,
  getShopData: shopActions.getShopData,
  resetShopDetail: shopActions.resetShopDetail
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PromotionMobile, _Component);

  function PromotionMobile(props) {
    (0, _classCallCheck3.default)(this, PromotionMobile);
    return (0, _possibleConstructorReturn3.default)(this, (PromotionMobile.__proto__ || (0, _getPrototypeOf2.default)(PromotionMobile)).call(this, props));
  }

  (0, _createClass3.default)(PromotionMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getAllReward({ pageSize: 1000 });
      this.props.getMyReward();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetShopDetail();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.REWARD_LIST_AT_SPA.loading !== nextProps.REWARD_LIST_AT_SPA.loading && !nextProps.REWARD_LIST_AT_SPA.loading && this.props.getOffset) {
        this.props.getOffset();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Promotion.scss');
      var _props = this.props,
          tabHome = _props.tabHome,
          tracking = _props.tracking,
          manualTrack = _props.manualTrack;
      var _props2 = this.props,
          ALL_REWARD_LIST = _props2.ALL_REWARD_LIST,
          REWARD_LIST_NO_STAR = _props2.REWARD_LIST_NO_STAR,
          REWARD_LIST_FIVE_STAR = _props2.REWARD_LIST_FIVE_STAR;

      var spaStyle = void 0,
          fiveStarStyle = void 0;
      if (tabHome === 'spa') {
        spaStyle = styles.spaSelected;
        fiveStarStyle = '';
      } else if (tabHome === '5star') {
        fiveStarStyle = styles.fiveStarSelected;
        spaStyle = '';
      } else {
        spaStyle = '';
        fiveStarStyle = '';
      }
      if (ALL_REWARD_LIST.data && ALL_REWARD_LIST.data.length > 0) {
        return _react2.default.createElement(
          'div',
          { className: styles.container },
          _react2.default.createElement(
            'div',
            { className: styles.navigateBar },
            _react2.default.createElement(
              'div',
              {
                className: styles.screen + ' ' + spaStyle,
                onClick: function onClick() {
                  return _this2.props.changeHomeTab('spa');
                }
              },
              tabHome !== 'spa' && _react2.default.createElement('div', { className: styles.redDot }),
              _react2.default.createElement(
                'div',
                { className: styles.text },
                'Tr\u1EA3i nghi\u1EC7m'
              )
            ),
            REWARD_LIST_FIVE_STAR.data.length !== 0 && _react2.default.createElement(
              'div',
              {
                className: styles.screen + ' ' + fiveStarStyle,
                onClick: function onClick() {
                  return _this2.props.changeHomeTab('5star');
                }
              },
              _react2.default.createElement('img', {
                src: tabHome === '5star' ? _Images2.default.home.fiveStarIcon : _Images2.default.home.inactiveFiveStarIcon,
                className: styles.fiveStarIcon
              }),
              _react2.default.createElement(
                'div',
                { className: styles.text },
                'N\u0103m sao'
              )
            )
          ),
          tabHome === 'spa' && _react2.default.createElement(_PromotionAtSpa2.default, {
            title: '\u01AFu \u0111\xE3i t\u1EA1i spa',
            tracking: (0, _extends3.default)({}, tracking, { section: 'Trải nghiệm' }),
            manualTrack: manualTrack,
            tabOn: true,
            history: this.props.history
          }),
          tabHome === '5star' && _react2.default.createElement(_FiveStarPromotion2.default, {
            tracking: (0, _extends3.default)({}, tracking, { section: 'Năm sao' }),
            manualTrack: manualTrack,
            tabOn: true,
            history: this.props.history
          })
        );
      } else if (REWARD_LIST_NO_STAR.data && REWARD_LIST_NO_STAR.data.length > 0) {
        return _react2.default.createElement(_PromotionAtSpa2.default, {
          tracking: (0, _extends3.default)({}, tracking, { section: 'Ưu đãi tại spa' }),
          manualTrack: manualTrack,
          history: this.props.history
        });
      }

      return _react2.default.createElement('div', null);
    }
  }]);
  return PromotionMobile;
}(_react.Component), _class2.propTypes = {
  // @data
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  REWARD_LIST_NO_STAR: _react.PropTypes.object,
  REWARD_LIST_FIVE_STAR: _react.PropTypes.object,
  ALL_REWARD_LIST: _react.PropTypes.object,
  REWARD_LIST_AT_SPA: _react.PropTypes.object,
  SERVICE_OF_HOME_SERVICE: _react.PropTypes.object,
  tabHome: _react.PropTypes.string,
  noCallHomeService: _react.PropTypes.bool,
  tracking: _react.PropTypes.object,
  // @action
  getAllReward: _react.PropTypes.func,
  getRewardAtHome: _react.PropTypes.func,
  getOffset: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  getRewardAtSpa: _react.PropTypes.func,
  changeHomeTab: _react.PropTypes.func,
  loadServiceOfHomeService: _react.PropTypes.func,
  getShopData: _react.PropTypes.func,
  resetShopDetail: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PromotionMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/Promotion.js
// module id = 1605
// module chunks = 0